import { render, staticRenderFns } from "./AmetrasTextAreaFieldTemplate.vue?vue&type=template&id=186bcabf&"
import script from "./AmetrasTextAreaFieldTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasTextAreaFieldTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasTextAreaFieldTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
